<pr-new-local-table
    panel-body
    class="flex flex-grow"
    [tableData]="tableData"
    [columnsData]="columnsData"
    [tableId]="tableId"
    [canNavigate]="false"
    [isLoading]="isLoading"
    [extraHeaderFieldTmpl]="extraHeader"
    [customCellTmpl]="customCell"
    [customCellName]="'editContract'"
>
    <ng-template #extraHeader>
        <div fxLayout="row" fxLayoutAlign="flex-start center" class="">
            <mat-icon
                (click)="addPriceContract()"
                class="text-primary"
                style="cursor: pointer"
                >add</mat-icon
            >
        </div>
    </ng-template>
    <ng-template #customCell let-row>
        <div fxLayout="row" fxLayoutAlign="center center">
                <mat-icon
                    (click)="updatePriceContract(row)"
                    class="text-primary"
                    style="cursor: pointer"
                >
                    edit
                </mat-icon>/
                <mat-icon
                    (click)="deletePriceContract(row.id)"
                    class="text-red"
                    style="cursor: pointer"
                >
                    delete
                </mat-icon>
        </div>
    </ng-template>
</pr-new-local-table>
